import { Entity } from "../common/base/entity/entity";
import { ProcessFlowAction } from "./processFlowAction";

class ProcessFlowEntity extends Entity {
  constructor(options) {
    super(options);
  }
}

const actionsMeta = {};

const screens = {
  list: {
    items: [{ name: "label", type: "link" }],
    multiselect: false,
    layoutType: {
      type: ["Grid"],
      excluded: {
        sort: true,
        filter: true,
      },
    },
  },
};

const fieldsMeta = {
  label: {
    label: "Process Name",
  },
};

const ProcessFlow = new ProcessFlowEntity({
  ActionClass: ProcessFlowAction,
  actionsMeta,
  propFields: actionsMeta,
  tabsMeta: {},
  screens,
  fieldsMeta,
  name: "Process Flows",
  title: "Process Flows",
  bKeys: ["id"],
  idKey: ["processName"],
  entityUrlPaths: {
    default: "bpm/ProcessFlow",
    getAll: "bpm/ProcessFlow",
    upsert: "bpm/ProcessFlow/upsertState",
    updateRedirectPath: "/tickets/ProcessFlow/OverriddenStates/",
  },
  fetchDetailByApi: true,
}); 

const ProcessFlowListSearchContainer = ProcessFlow.getContainer("ListSearch");

export { ProcessFlowListSearchContainer };
